import { Copy, Facebook, Linkedin, MessageCircle, Mail, Smartphone, Twitter, Instagram } from "lucide-react";
import { toast } from "sonner";

const enc = encodeURIComponent;
const copy = (t, msg = "Copied") => { navigator.clipboard?.writeText(t); toast.success(msg); };

export const ShareButtons = ({ url, text, id }) => {
  const full = `${text ? text + " " : ""}${url}`;
  const items = [
    ["facebook", Facebook, "bg-[#1877F2]", `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}&quote=${enc(text || "")}`],
    ["x", Twitter, "bg-black", `https://twitter.com/intent/tweet?text=${enc(text || "")}&url=${enc(url)}`],
    ["linkedin", Linkedin, "bg-[#0A66C2]", `https://www.linkedin.com/sharing/share-offsite/?url=${enc(url)}`],
    ["whatsapp", MessageCircle, "bg-[#25D366]", `https://wa.me/?text=${enc(full)}`],
    ["sms", Smartphone, "bg-slate-700", `sms:?&body=${enc(full)}`],
    ["email", Mail, "bg-slate-500", `mailto:?subject=${enc(text || "Check this out")}&body=${enc(full)}`],
  ];
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={`share-${id}`}>
      {items.map(([k, I, c, href]) => <a key={k} href={href} target="_blank" rel="noreferrer" title={`Share on ${k}`} className={`${c} text-white w-8 h-8 rounded-lg flex items-center justify-center hover:opacity-85 transition-opacity`} data-testid={`share-${id}-${k}`}><I className="w-4 h-4" /></a>)}
      <button onClick={() => copy(full, "Caption + link copied — paste it into Instagram or TikTok")} title="Copy for Instagram / TikTok" className="bg-gradient-to-br from-pink-500 to-amber-400 text-white w-8 h-8 rounded-lg flex items-center justify-center" data-testid={`share-${id}-instagram`}><Instagram className="w-4 h-4" /></button>
      <button onClick={() => copy(url, "Link copied")} className="border border-slate-300 text-slate-600 h-8 px-2.5 rounded-lg text-xs font-semibold flex items-center gap-1" data-testid={`share-${id}-copy`}><Copy className="w-3.5 h-3.5" />Copy link</button>
    </div>
  );
};
